import { useLocation } from 'react-router-dom'
import { QueryParamNames } from 'types/global'
import { StringParam, useQueryParams } from 'use-query-params'

export const useCurrentHashPath = () => {
  const { hash } = useLocation()

  return hash.split('?')[0]
}

export const useProfileParams = () => {
  const [
    {
      section,
      subSectionResults,
      vsPlayerId,
      [QueryParamNames.PROFILE_PLAYER_ID]: playerId,
      [QueryParamNames.PROFILE_TENNIS_ID]: tennisId,
      [QueryParamNames.PROFILE_OWN_PROFILE_FLAG]: ownProfileParam,
    },
    setQuery,
  ] = useQueryParams({
    section: StringParam,
    [QueryParamNames.PROFILE_RESULTS_SUB_SECTION]: StringParam,
    [QueryParamNames.PROFILE_PLAYER_ID]: StringParam,
    [QueryParamNames.PROFILE_TENNIS_ID]: StringParam,
    [QueryParamNames.PROFILE_OWN_PROFILE_FLAG]: StringParam,
    [QueryParamNames.PROFILE_H2H_OPPONENT_ID]: StringParam,
  })

  return {
    section,
    subSectionResults,
    tennisId,
    playerId,
    vsPlayerId,
    hasOwnProfileFlag: ownProfileParam === 'true',
    setQueryParams: setQuery,
  }
}
